import { render, staticRenderFns } from "./MbBadgeWon.vue?vue&type=template&id=31d185da&"
import script from "./MbBadgeWon.vue?vue&type=script&lang=js&"
export * from "./MbBadgeWon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports